import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  document.body.innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;font-family:system-ui;text-align:center;padding:2rem;">
      <h2 style="color:#0f172a;margin-bottom:1rem;">Application Error</h2>
      <p style="color:#64748b;margin-bottom:1.5rem;">Root element not found. Please reload the page.</p>
      <button onclick="window.location.reload()" style="background:#0052CC;color:white;border:none;padding:0.75rem 1.5rem;border-radius:0.5rem;cursor:pointer;">Reload</button>
    </div>
  `;
  throw new Error("Root element not found");
}

try {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error("Failed to render application:", error);
  rootElement.innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;font-family:system-ui;text-align:center;padding:2rem;">
      <h2 style="color:#0f172a;margin-bottom:1rem;">Application Error</h2>
      <p style="color:#64748b;margin-bottom:1.5rem;">Failed to initialize. Please reload the page.</p>
      <button onclick="window.location.reload()" style="background:#0052CC;color:white;border:none;padding:0.75rem 1.5rem;border-radius:0.5rem;cursor:pointer;">Reload</button>
    </div>
  `;
}
